import classNames from 'classnames'
import styles from './PopupArrow.module.css'
import { type AnchorProps, Position } from '../types'

function PopupArrow({ x, position, className }: AnchorProps) {
  return (
    <div
      className={classNames(styles.tooltipArrow, className, {
        [styles.bottomTooltipArrow!]: position === Position.BOTTOM,
        [styles.topTooltipArrow!]: position === Position.TOP,
      })}
      style={{ transform: `translateX(${x}px) ${position === Position.BOTTOM ? ' rotate(180deg)' : ''}` }}
    ></div>
  )
}

export default PopupArrow
